export function getDomainName(): string {
  const { hostname } = window.location;
  return hostname;
}

function isBetaProdDomain(): boolean {
  const currentDomain = getDomainName();
  if (currentDomain === process.env.REACT_APP_RMP_BETA_DOMAIN_NAME) return true;
  return false;
}

export const isBetaDomain = isBetaProdDomain();
